import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { NormalizedEmailSchema } from '../shared/normalizedEmail';
import { parseBeaconBody } from './analytics';

const LinkInBioSignupBodySchema = z
  .object({
    seller: ObjectIdStringValidationSchema,
    block: ObjectIdStringValidationSchema,
    email: NormalizedEmailSchema,
    // A field people never see: only bots fill it in.
    website: z.string().max(500).nullish(),
  })
  .meta({ id: 'LinkInBioSignupRequest' });

// Sent as text/plain like the analytics beacon, so the store's request needs no CORS preflight.
export const LinkInBioSignupRequestValidationSchema = z.preprocess(
  parseBeaconBody,
  LinkInBioSignupBodySchema,
);

export type LinkInBioSignupRequest = z.infer<typeof LinkInBioSignupBodySchema>;
